import { render, staticRenderFns } from "./descuentos.vue?vue&type=template&id=1e948b78"
import script from "./descuentos.vue?vue&type=script&lang=js"
export * from "./descuentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports